import { gql } from '@apollo/client'

export const DELETE_NOTIFICATION_MUTATION = gql`
  mutation deleteNotification($id: ID!) {
    deleteNotification(id: $id) {
      success
      errors
    }
  }
`
